import { ReactNode } from 'react';

import { Select, styled } from '@mui/material';

import DropdownIcon from '../assets/buttons-icons/dropdown.svg?react';
import palette from '../theme/palette';

const StyledDropdown = styled(Select)(() => ({
  padding: '12px 10px',
  alignItems: 'center',
  gap: '14px',
  width: '100%',
  height: '42px',
  borderRadius: '8px',
  border: `1px solid ${palette.stroke.idle}`,
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  }
}));

interface DropdownProps {
  children: ReactNode;
  [key: string]: unknown;
}

const Dropdown = ({ children, ...props }: DropdownProps) => {
  return (
    <StyledDropdown IconComponent={DropdownIcon} {...props}>
      {children}
    </StyledDropdown>
  );
};

export default Dropdown;
